import { FlagIcon } from "../flag-icon";
import { useCallback } from "react";
import { countries } from "src/assets/data";

type OwnProps = {
    countryCode: string;
}

const CountryWithFlag = ({ countryCode }: OwnProps) => {

    const getCountryByCode = useCallback((inputValue: string) => {
        const country = countries.find((x) => x.code === inputValue);

        return country?.label || "";
    }, []);

    return (
        <>
            <FlagIcon
                code={countryCode}
                sx={{
                    mr: 1,
                    verticalAlign: "middle",
                    border: "1px solid #c5c5c5"
                }}
            />
            {getCountryByCode(countryCode)}
        </>
    )
}

export default CountryWithFlag;